export default {
  title01: "বর্তমান আবহাওয়া",
  title02: "২৪ ঘন্টা",
  title03: "১০ দিনের আবহাওয়ার পূর্বাভাস দেখুন",
  title04: "AQI",
  title05: "সকল তথ্য দেখুন",
  title06: "সূর্যোদয় এবং সূর্যাস্ত",
  title07: "চাঁদের পর্যায়",
  title08: "পরবর্তী পূর্ণিমা",
  title09: "পরবর্তী অমাবস্যা",
  title10: "দিন",
  title11: "রাত",
  title12: "সূর্যোদয়",
  title13: "সূর্যাস্ত",
  title14: "চন্দ্রোদয়",
  title15: "চন্দ্রাস্ত",
  title16: "উৎস",
  title17: "শুরু",
  title18: "শেষ",
  title19: "বর্তমান অবস্থান ব্যবহার করুন",
  title20: "শহর অনুসন্ধান করুন",
  title21: "ভালো লাগছে",
  title22: "ভালো লাগছে (ছায়া)",
  title23: "এখন",
  title24: "আজ",
  title25: "রবিবার",
  title26: "সোমবার",
  title27: "মঙ্গলবার",
  title28: "বুধবার",
  title29: "বৃহস্পতিবার",
  title30: "শুক্রবার",
  title31: "শনিবার",
  title32: "লোড হচ্ছে...",
  title33: "এখন",
  title34: "প্রতি ঘণ্টা",
  title35: "প্রতিদিন",
  title36: "সূর্য ও চন্দ্র",
  title37: "বাতাসের মান",
  title38: "যোগাযোগ করুন: xlf550402@gmail.com",
  title39: "গোপনীয়তা চুক্তি",
  title40: "কপিরাইট © comfortweather.com ২০২০ - ২০২৪। সর্বস্বত্ব সংরক্ষিত।",
  title41: "",
  title42: "হাই",
  title43: "লো",
  title44: "গ্রহণ করুন",
  title45:
    "ComfortWeather ব্যবহারের জন্য আপনাকে ধন্যবাদ! আপনার আইনি অধিকার এবং স্বার্থ আরও ভালভাবে রক্ষা করার জন্য, ব্যবহারের আগে দয়া করে ",
  title46: "গোপনীয়তা নীতি",
  title47: " সাবধানে পড়ুন।",
  title48: "দ্বারা সরবরাহিত তথ্য",
  title49: "যোগাযোগ করুন: xyjph123@gmail.com",
  title50: "কপিরাইট © 24hweather.com ২০২০ - ২০২৪। সর্বস্বত্ব সংরক্ষিত।",
  title51:
    "24hweather ব্যবহারের জন্য আপনাকে ধন্যবাদ! আপনার আইনি অধিকার এবং স্বার্থ আরও ভালভাবে রক্ষা করার জন্য, ব্যবহারের আগে দয়া করে ",
  title52: "তোমার অবস্থান পরিবর্তন হয়েছে। তুমি কি এটা আপডেট করতে চাও?",
  title53: "নিশ্চিত করা",
  title54: "বাতিল করুন",
  title55: "পিছনে",
  title56: "সংবাদ",
  title57: "আবহাওয়ার আপডেট হচ্ছে...",
  title58: "আবহাওয়া আপডেট করা হয়েছে",
  title59: "সবগুলো দেখুন",
  title60: "কপিরাইট © mobi321.com ২০২০ - ২০২৪। সর্বস্বত্ব সংরক্ষিত।",
  title61: "গতকাল",
  title62: "আগামীকাল",
  title63: "১৫ দিনের আবহাওয়ার পূর্বাভাস দেখুন",
  title64: "আজকের বিস্তারিত",
  title65: "Rahu Kaal",
  title66: "লাইফস্টাইল ইনডেক্স",
  title67: "লাইফস্টাইল ইনডেক্স",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "শুকানো কঠিন",
  title103: "ধীরে শুকানো",
  title104: "ভালোভাবে শুকায়",
  title105: "খুব দ্রুত শুকানো",
  title106: "খুব দ্রুত শুকানো",

  title107: "উপযুক্ত নয়",
  title108: "বিনয়ী অভিজ্ঞতা",
  title109: "জলের মজার জন্য ভালো",
  title110: "খুবই উপযুক্ত",
  title111: "নিখুঁত অবস্থা",

  title112: "স্বাস্থ্যের জন্য সহায়ক",
  title113: "নিরপেক্ষ অবস্থা",
  title114: "ঝুঁকি একটু বেশি",
  title115: "উচ্চ ঝুঁকি",
  title116: "চরম ঝুঁকিতে",

  title117: "উপযুক্ত নয়",
  title118: "কিছুটা উপযুক্ত",
  title119: "বাইরের জন্য ভালো",
  title120: "খুবই উপযুক্ত",
  title121: "চমৎকার অবস্থা",

  title122: "খুব শুষ্ক অবস্থা",
  title123: "সম্ভবত শুষ্ক",
  title124: "সামান্য শুষ্ক",
  title125: "খুব অসম্ভব শুষ্ক",
  title126: "খুব অসম্ভব শুষ্ক",

  title127: "সুপারিশ করা হয় না",
  title128: "গ্রহণযোগ্য",
  title129: "শুভ দিন",
  title130: "খুব ভালো অবস্থা",
  title131: "আদর্শ অবস্থা",
};
